import {initialize as initializeForms} from "redux-form";

export const initTestingForm = () => (dispatch, getState) => {

    dispatch(initializeForms('testing',
        {
            testing: getState().cart.testing
        }
    ))

}



/** WEBPACK FOOTER **
 ** ./src/actions/Testing.js
 **/